var _g;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPause(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "pause-button",
    xmlns: "http://www.w3.org/2000/svg",
    width: 29.449,
    height: 48.354,
    viewBox: "0 0 29.449 48.354",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_55426",
    "data-name": "Group 55426",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_85332",
    "data-name": "Path 85332",
    d: "M14.246,0A5.259,5.259,0,0,0,8.987,5.259V43.095a5.259,5.259,0,0,0,10.517,0V5.259A5.257,5.257,0,0,0,14.246,0Z",
    transform: "translate(-8.987)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_85333",
    "data-name": "Path 85333",
    d: "M32.246,0a5.259,5.259,0,0,0-5.259,5.259V43.095a5.259,5.259,0,0,0,10.517,0V5.259A5.259,5.259,0,0,0,32.246,0Z",
    transform: "translate(-8.056)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPause);
export default __webpack_public_path__ + "static/media/pause.38569658cec26ff5bf01b97cc0ec2f8e.svg";
export { ForwardRef as ReactComponent };